import { Routes, Route, Navigate } from "react-router-dom";
import Login from "pages/sign-in";
import PublicRoute from "components/PublicRoute";
import ForgotPassword from "pages/forgot-password";
import Callback from "pages/callback";

const PublicRoutes = () => {
    return (
        <Routes>
            <Route
                path="/"
                element={
                    <PublicRoute>
                        <Login />
                    </PublicRoute>
                }
            />
            <Route
                path="/login"
                element={<Navigate to="/" replace />}
            />
            <Route
                path="/sign-in"
                element={
                    <PublicRoute>
                        <Login />
                    </PublicRoute>
                }
            />
            <Route
                path="/forgot-password"
                element={
                    <PublicRoute>
                        <ForgotPassword />
                    </PublicRoute>
                }
            />
            <Route
                path="/callback"
                element={
                    <Callback />
                }
            />
        </Routes>
    );
};

export default PublicRoutes;
